<div class="fa-disclosure-wrapper">
  <div class="fa-wrapper-right">
      <div class="fa-flex-btn-exit">
        <div class="d-button-container">
          <i class="fas fa-times" (click)="close()" onkeypress="close()"></i>
        </div>
      </div>
  </div>

  <div class="fa-disclosure">

    <div class="fa-top">
      <div class="fa-header">
       
        <p class="header-2"> CONSENT TO COMPLETE LIFE INSURANCE TRANSACTION ELECTRONICALLY </p>
      </div>
    </div>

    <div class="fa-disclosure-body">
      <mat-dialog-content class="fa-disclosure-modal">

        <!-- row -->
        <div class="row fa-row">

          <p>
            This electronic life insurance transaction process takes place over the internet using electronic records,
            transactions and signatures. During this electronic life insurance transaction process, you agree to sign
            with
            an electronic signature at various places in the process and accept electronic delivery of notices and
            required
            disclosure documents including your life insurance policy (if applicable). Further, you agree to receive
            communications
            related to your life insurance policy via SMS text message. To provide the consent, you will need a device
            with access
            to the internet in addition to Adobe software as described below. You should print (or store locally on your
            own device)
            and maintain a copy of all documents presented to you as part of this electronic life insurance transaction
            process.
            We also recommend that you have the capability to print copies of certain online screens and documents
            presented through the process.
          </p>

          <p>
            To continue with this electronic life insurance transaction process, including but not limited to applying
            your electronic signature
            to the transaction form(s) and accepting electronic delivery of any notices and required disclosure
            documents including your life insurance
            policy (if applicable), you must provide your consent below.
          </p>
          <p *ngIf="data.stateOfIssue ==='5343'">
            Providing your consent to receive documents electronically is voluntary. You also have the option of completing 
            the life insurance transaction through our offline process utilizing paper forms.
            If you do not wish to complete this life insurance transaction electronically, simply click on the "x" in
            the upper right-hand
            corner of the screen to close the internet browser window on your computer and contact your insurance agent
            to assist you with
            completing our offline paper process. In addition, if you provide your consent below and then withdraw it,
            we cannot process
            your transaction electronically.
          </p>
          <p *ngIf="data.stateOfIssue !='5343'">
            You also have the option of completing the life insurance transaction through our offline process utilizing
            paper forms.
            If you do not wish to complete this life insurance transaction electronically, simply click on the "x" in
            the upper right-hand
            corner of the screen to close the internet browser window on your computer and call 1-800-721-3774 so that a Coverage Coach may direct you to a local agent 
            that can assist you with
             our offline paper process. In addition, if you provide your consent below and then withdraw it,
            we cannot process
            your transaction electronically.
          </p>

          <p>
            <strong class="force-bold1">All signing records and disclosure documents will be provided electronically</strong> <br><br>
            We will provide electronically to you all records and documents provided during the electronic life
            insurance
            transaction process, and you will be required to sign such documents electronically where indicated. We may
            also
            be required to provide you with certain disclosure documents in connection with this transaction. All
            notices and
            required disclosure documents relating to this specific insurance transaction will be delivered to you
            electronically.
            Further, you may receive communications related to your life insurance policy via SMS text message. By
            proceeding with
            the electronic life insurance transaction process, you will receive records, notices and documents
            electronically in
            accordance with the terms of this consent.
          </p>

          <ul>
            <li>
              You must have an account with an internet service provider and be able to send and receive emails with
              hyperlinks to
              websites and attached files. To report a change or correction in your email address, please contact us as
              described below.
            </li>

            <li>
              Certain electronic documents will be delivered in Adobe Acrobat* Portable Document Format (PDF). To view,
              download, save
              or print in this format, you must have or install Adobe Acrobat* Reader on your computer. If you don't
              have Adobe Acrobat Reader
              on your computer, it can be obtained, free of charge, by clicking on the link below.
              <br><br>
              <a href="https://get.adobe.com/reader/">Adobe Reader Download </a>
            </li>

            <li>
              To receive communications via SMS text message, you must have a phone with the ability to receive SMS text
              messages.
              To report a change or correction in your phone number, please contact us as described below.
            </li>

            <li>
              While we do not charge a fee for providing electronic disclosure documents, you may incur internet access
              charges,
              phone charges, message or data rate charges, and other third-party charges when receiving electronic
              documents or SMS text messages,
              or downloading required software. Your ability to access or transact business through this electronic
              process may be limited due
              to circumstances beyond our control, such as system outages.
            </li>
          </ul>

          <p>
            *Adobe, the Adobe logo and Acrobat are either the registered trademarks or trademarks of Adobe Systems,
            Incorporated in the United States and/or other countries.
          </p>

          <p>
            We may elect to send certain records to you via the US Postal Service. Therefore, you should be diligent in
            updating your
            US postal address with us if it changes, which you can do as described below.
          </p>

          <p>
            When you receive an email from us alerting you that a message or document is waiting for you, you should
            promptly read the
            email and, if applicable, access the link included in the email to the site with the message or document.
            From time to time we
            may send important and time sensitive materials, including your policy and other important notices, via an
            email alerting you to
            such materials. Your rights relating to your insurance coverage, including any right to return the policy if
            you are not satisfied
            with it during its “free look” period, may be dependent on when you receive information from us. You will be
            considered to have
            received information from us when we notify you at the email address you have provided to us alerting you
            that the message or
            document is waiting for you. Therefore, you should be diligent in updating your email address with us if it
            changes,
            which you can do as described below.
          </p>

         <p *ngIf="data.stateOfIssue =='5343'"><strong class="force-bold1"> Getting paper copies </strong> <br><br>
            You will have the ability to download, save and print documents we present to you throughout this process.
            If you wish for us to send you paper copies of any such documents from our office to you or if you wish to
            withdraw
            your consent to receive future documents from us electronically, you must contact us as described below. </p>
            <p *ngIf="data.stateOfIssue !='5343'"><strong class="force-bold1"> Getting paper copies </strong> <br><br>
              You will have the ability to download, save and print documents we present to you throughout this process.
              If you wish for us to send you paper copies of any such documents from our office to you or if you wish to
              withdraw
              your consent to receive future documents from us electronically, you must contact us as described below.
              If you request a paper copy of your life insurance policy, you may be charged up to $25 for such copy. </p>

           
          <p *ngIf="data.stateOfIssue !='5343'"><strong class="force-bold1"> Contacting us </strong> <br><br>
            You can contact us regarding changing your US postal address, email address or phone number, obtaining a
            paper copy of
            records previously provided to you, or withdrawing your consent to receive future records electronically by calling
             1-800-721-3774.
          </p>
          <p  class="force-bold1" *ngIf="data.stateOfIssue ==='5343'"><strong> Contacting us </strong> <br><br>
            You can contact us regarding changing your US postal address, email address or phone number, obtaining a
            paper copy of
            records previously provided to you, or withdrawing your consent to receive future records electronically by  
            notifying your
            insurance agent or contacting us at 1-800-505-9427, Option 1.
          </p>
          <p><strong class="force-bold1"> Statement of consent </strong> <br><br> By checking the box, I confirm to John Hancock that:</p>


        </div>
        <!-- /row -->

        <!-- row -->
        <div class="row fa-row">
          <ol>
            <li>
              I agree to the terms in this Consent; and
            </li>

            <li>
              I can send and receive emails with hyperlinks to websites and attached files; and
            </li>

            <li>
              I have the ability to receive SMS text messages on my phone.
            </li>
          </ol>
        </div>
        <!-- /row -->

        <mat-dialog-actions>
          <button class="btn btn-primary disclosure-button" (click)="this.close()">I agree</button>
        </mat-dialog-actions>

      </mat-dialog-content>
    </div>

  </div>


</div>
